import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styled';

const WorklogItemPlaceholder = ({
  showDivider,
  shouldDisplayCard,
  cardNamePlacement,
}) => (
  <S.WorklogItemPlaceholder>
    <S.Avatar />
    <S.Columns>
      <S.Title />
      {cardNamePlacement === 'body' && shouldDisplayCard && <S.CardName />}
      <S.Footer />
      {showDivider && <S.Divider />}
    </S.Columns>
  </S.WorklogItemPlaceholder>
);

WorklogItemPlaceholder.propTypes = {
  showDivider: PropTypes.bool,
  shouldDisplayCard: PropTypes.bool,
  cardNamePlacement: PropTypes.oneOf(['title', 'body']),
};
WorklogItemPlaceholder.defaultProps = {
  showDivider: false,
  shouldDisplayCard: true,
  cardNamePlacement: 'title',
};

export default WorklogItemPlaceholder;
